import { SchadenmeldungKostenPositionApi } from "../../../../../shared/models/generated/SchadenmeldungSchadenmeldungKostenPositionApi";
import { SchadenmeldungKostenRequestApi } from "../../../../../shared/models/generated/SchadenmeldungSchadenmeldungKostenRequestApi";
import { AppApplicationModel } from "./AppApplicationModel";
import { UploadModel } from "../../../../../shared/models/view/Upload";
import { ZusammenfassungStrukturApi } from "../../../../../shared/models/generated/SchadenmeldungZusammenfassungStrukturApi";
import { User } from '../../../../../shared/models/api/User/User';
import { SchadenmeldungAksApi } from '../../../../../shared/models/generated/AksSchadenmeldungAksApi';
import { SchadenTypAksApi } from '../../../../../shared/models/generated/AksSchadenTypAksApi';
import { SchadenAksUnfallApi } from '../../../../../shared/models/generated/AksSchadenAksUnfallApi';
import { SchadenAksDatenPersonApi } from '../../../../../shared/models/generated/AksSchadenAksDatenPersonApi';
import { SchadenAksKrankheitApi } from '../../../../../shared/models/generated/AksSchadenAksKrankheitApi';
import { SchadenAksDokumenteApi } from '../../../../../shared/models/generated/AksSchadenAksDokumenteApi';
import { SchadenmeldungLandApi } from '../../../../../shared/models/generated/SchadenmeldungSchadenmeldungLandApi';
import { PersonenAksApi } from "../../../../../shared/models/generated/AksPersonenAksApi";
import { SchadenmeldungUploadDatenExtendedApi } from "../../../../../shared/models/generated/SchadenmeldungSchadenmeldungUploadDatenExtendedApi";
import { SchadenmeldungUploadDatenApi } from "../../../../../shared/models/generated/SchadenmeldungSchadenmeldungUploadDatenApi";
import { CheckboxStateEnum } from "../../../../../shared/enums/CheckboxSelectionType";
import { DamageDeclarationAdapter } from "../../../../../shared/models/adapter/DamageDeclarationAdapter";

export class AppModelAdapter extends DamageDeclarationAdapter {

	private static readonly API_DATE_FORMAT: string = 'YYYY-MM-DD';
	private static readonly VIEW_DATE_FORMAT: string = 'DD.MM.YYYY';

	public static getKostenRequest(kostenSummen: { [id: string]: string }): SchadenmeldungKostenRequestApi {
		const apiModel = new SchadenmeldungKostenRequestApi();
		apiModel.Schadenkosten = new Array<SchadenmeldungKostenPositionApi>();

		Object.keys(kostenSummen).forEach((key) => {
			const costRequest: SchadenmeldungKostenPositionApi = new SchadenmeldungKostenPositionApi();
			costRequest.Betrag = parseFloat(kostenSummen[key].replace(',', '.'));
			costRequest.Code = key;
			apiModel.Schadenkosten.push(costRequest);
		});

		return apiModel;
	}

	public static getSchadenmeldungSchutzbriefRequestApi(formModel: AppApplicationModel, uploadModel: UploadModel, summaryModel: ZusammenfassungStrukturApi, user: User): SchadenmeldungAksApi {
		const model = new SchadenmeldungAksApi();
		model.SchadenTyp = parseInt(formModel.DamageFormModel.SchadenTyp);
		model.Dokumente = this.getDokumente(formModel, uploadModel);
		model.PersoenlicheDaten = this.getPersoenlicheDaten(formModel, user);
		model.DokumentId = formModel.Vorgangsnummer;
		model.ProzessStufe = 3;
		model.StrukturUebersichtSeite = summaryModel;

		switch (Number(model.SchadenTyp)) {
			case SchadenTypAksApi.Krankheit:
				model.DatenKrankheit = this.getDatenKrankheit(formModel);
				break;
			case SchadenTypAksApi.Unfall:
				model.DatenUnfall = this.getDatenUnfall(formModel);
				break;
		}
		return model;
	}

	public static getPersoenlicheDaten(formModel: AppApplicationModel, user: User): SchadenAksDatenPersonApi {
		const apiModel = new SchadenAksDatenPersonApi();
		apiModel.TelefonNummer = formModel.PersonalDataFormModel.PersoenlicheDaten.TelefonNummer;
		apiModel.TelefonVorwahl = formModel.PersonalDataFormModel.PersoenlicheDaten.TelefonVorwahl;
		apiModel.Email = formModel.PersonalDataFormModel.PersoenlicheDaten.Email;
		apiModel.Iban = formModel.PersonalDataFormModel.Iban;
		apiModel.Kontoinhaber = formModel.PersonalDataFormModel.Kontoinhaber;
		apiModel.Mitgliedsnummer = user.Valid ? user.MglNo : formModel.PersonalDataFormModel.PersoenlicheDaten.Mitgliedsnummer;
		apiModel.Vorname = user.Valid ? user.UserData.Vorname : formModel.PersonalDataFormModel.PersoenlicheDaten.Vorname;
		apiModel.Nachname = user.Valid ? user.UserData.Nachname : formModel.PersonalDataFormModel.PersoenlicheDaten.Nachname;
		apiModel.Ort = formModel.PersonalDataFormModel.PersoenlicheDaten.Adresse.Ort;
		apiModel.Plz = formModel.PersonalDataFormModel.PersoenlicheDaten.Adresse.Postleitzahl;
		apiModel.Strasse = formModel.PersonalDataFormModel.PersoenlicheDaten.Adresse.StrasseHausnummer;

		if (user.UserData.Firma) {
			apiModel.Firma = user.UserData.Firma;
			apiModel.Beguenstigter = user.UserData.Beguenstigter;
		}
		return apiModel;
	}

	public static getDatenKrankheit(formModel: AppApplicationModel): SchadenAksKrankheitApi {
		const apiModel = new SchadenAksKrankheitApi();
		apiModel.Datum = moment(formModel.DamageFormModel.SchadenStartDatum, this.VIEW_DATE_FORMAT).format(this.API_DATE_FORMAT);
		apiModel.Land = new SchadenmeldungLandApi();
		apiModel.Land.Land = formModel.DamageFormModel.SchadenLandName;
		apiModel.Land.LandKnz = formModel.DamageFormModel.SchadenLand;
		apiModel.Abreisedatum = moment(formModel.DamageFormModel.AbreiseDatum, this.VIEW_DATE_FORMAT).format(this.API_DATE_FORMAT);
		apiModel.Beschreibung = formModel.DamageFormModel.EigeneAngabenBeschreibung;
		apiModel.BetroffenePerson = PersonenAksApi[formModel.DamageFormModel.BetroffenePerson as keyof typeof PersonenAksApi];
		apiModel.Nachname = formModel.DamageFormModel.BetroffenePersonNachname;
		apiModel.PersonGemeldet = this.evaluateCheckboxSelection(formModel.DamageFormModel.BetroffenePersonGemeldet);
		apiModel.Vorname = formModel.DamageFormModel.BetroffenePersonVorname;
		apiModel.Vorerkrankung = this.evaluateCheckboxSelection(formModel.DamageFormModel.Behandlung);

		apiModel.ZustimmungDatenverarbeitung = true;

		return apiModel;
	}

	public static getDatenUnfall(formModel: AppApplicationModel): SchadenAksUnfallApi {
		const apiModel = new SchadenAksUnfallApi();
		apiModel.Datum = moment(formModel.DamageFormModel.SchadenStartDatum, this.VIEW_DATE_FORMAT).format(this.API_DATE_FORMAT);
		apiModel.Land = new SchadenmeldungLandApi();
		apiModel.Land.Land = formModel.DamageFormModel.SchadenLandName;
		apiModel.Land.LandKnz = formModel.DamageFormModel.SchadenLand;
		apiModel.Abreisedatum = moment(formModel.DamageFormModel.AbreiseDatum, this.VIEW_DATE_FORMAT).format(this.API_DATE_FORMAT);
		apiModel.Beschreibung = formModel.DamageFormModel.EigeneAngabenBeschreibung;
		apiModel.BetroffenePerson = PersonenAksApi[formModel.DamageFormModel.BetroffenePerson as keyof typeof PersonenAksApi];
		apiModel.Nachname = formModel.DamageFormModel.BetroffenePersonNachname;
		apiModel.PersonGemeldet = this.evaluateCheckboxSelection(formModel.DamageFormModel.BetroffenePersonGemeldet);
		apiModel.Vorname = formModel.DamageFormModel.BetroffenePersonVorname;

		apiModel.ZustimmungDatenverarbeitung = true;

		return apiModel;
	}

	public static getDokumente(formModel: AppApplicationModel, uploadModel: UploadModel): SchadenAksDokumenteApi {
		const apiModel = new SchadenAksDokumenteApi();

		if (formModel.DocumentsBillsFormModel.Kostenart) {
			apiModel.DokBehandlungskosten = this.getUploadDataCostType(formModel.DocumentsBillsFormModel.BehandlungskostenBelege, uploadModel.UploadContainer['UploadCostTypetreatment']);
			apiModel.DokMedikamente = this.getUploadDataCostType(formModel.DocumentsBillsFormModel.MedikamenteBelege, uploadModel.UploadContainer['UploadCostTypemedications']);
			apiModel.DokSonstige = this.getUploadDataCostType(formModel.DocumentsBillsFormModel.SonstigeBelege, uploadModel.UploadContainer['UploadCostTypemisc']);
			apiModel.DokPatiententransport = this.getUploadDataCostType(formModel.DocumentsBillsFormModel.PatiententransportBelege, uploadModel.UploadContainer['UploadCostTypepatientTransport']);
		} else {
			apiModel.DokBehandlungskosten = new Array<SchadenmeldungUploadDatenExtendedApi>();
			apiModel.DokMedikamente = new Array<SchadenmeldungUploadDatenExtendedApi>();
			apiModel.DokSonstige = new Array<SchadenmeldungUploadDatenExtendedApi>();
			apiModel.DokPatiententransport = new Array<SchadenmeldungUploadDatenExtendedApi>();
		}
		apiModel.DokNachweisBelege = new Array<SchadenmeldungUploadDatenApi>();
		if (uploadModel && uploadModel.UploadContainer && uploadModel.UploadContainer['UploadProofs']) {
			apiModel.DokNachweisBelege = this.getUploadData(uploadModel.UploadContainer['UploadProofs']);
		}
		apiModel.DokAbreiseDeutschland = new Array<SchadenmeldungUploadDatenApi>();
		if (uploadModel && uploadModel.UploadContainer && uploadModel.UploadContainer['UploadDepatureProof']) {
			apiModel.DokAbreiseDeutschland = this.getUploadData(uploadModel.UploadContainer['UploadDepatureProof']);
		}

		return apiModel;
	}

	private static evaluateCheckboxSelection(state: CheckboxStateEnum): boolean {
		if (state === CheckboxStateEnum.CHECKBOX_YES) {
			return true;
		}
		return false;
	}
}